import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { GetDescriptionFields } from '.';
import ClaimTasksBarcodeImg from '../../../assets/img/claims/tasks/barcode.svg';
import ClaimTasksReportImg from '../../../assets/img/claims/tasks/report.svg';
import TasksImg from '../../../assets/img/claims/tasks/summary.svg';
import ClaimTasksImg from '../../../assets/img/claims/tasks/tasks.svg';
import { HeaderContent } from '../../../components/HeaderContent';
import { UnderLicenseClaim } from '../../../components/new-layout/UnderLicenseClaim';
import { Project } from '../../../domain/project/Project';
import { intl } from '../../../helpers/IntGlobalProvider';
import { useRetrieveSupportDocs } from '../../../hooks/support-docs/useRetrieveSupportDocs';
import { useRetrieveUser } from '../../../hooks/user/useRetrieveUser';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import { ObjectOfAny } from '../../../interfaces/common';
import Text from '../../../react-components/Text';

type ProjectSettingsTasksFieldsProps = {
  project: Project;
};

export const ProjectSettingsTasksFields = ({ project }: ProjectSettingsTasksFieldsProps) => {
  const { retrieveDoc } = useRetrieveSupportDocs();
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { data: user } = useRetrieveUser();
  const [descriptionFields, setDescriptionFields] = useState<ObjectOfAny>({ task: {} });

  useEffect(() => {
    if (project) {
      if (project.view) {
        setDescriptionFields({
          task: project.view.task || {},
        });
      }
    }
  }, [project]);

  if (!project) return null;

  if (!userCredentials?.subscription.test(`planner.tasks`)) {
    return (
      <UnderLicenseClaim
        headerText={intl.formatMessage({ id: `projects.settings.fields.tasks.under_gorilla_claim.title` })}
      >
        <Grid container direction="column" alignItems="center">
          <VSpacer large />
          <VSpacer medium />

          <Grid
            item
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ maxWidth: `700px` }}
          >
            <img src={TasksImg} alt="" height="200" width="200" />
            <VSpacer large />
            <Text
              variant="body-medium"
              style={{ textAlign: `center`, fontSize: `13px` }}
              intlId="projects.settings.fields.tasks.under_gorilla_claim.header"
            />
          </Grid>

          <VSpacer large />

          <VSpacer large />

          <Grid item container direction="row" style={{ gap: `20px` }} alignItems="flex-start" justifyContent="center">
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img src={ClaimTasksImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="projects.settings.fields.tasks.under_gorilla_claim.content.1"
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img src={ClaimTasksReportImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="projects.settings.fields.tasks.under_gorilla_claim.content.2"
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img src={ClaimTasksBarcodeImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="projects.settings.fields.tasks.under_gorilla_claim.content.3"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </UnderLicenseClaim>
    );
  }

  return (
    <div style={{ padding: `16px 22px` }}>
      <Grid container direction="column" style={{ padding: `16px 22px` }}>
        <Grid container direction="row" wrap="nowrap">
          <HeaderContent
            titleIntlId="projects.settings.fields.tasks.title"
            subtitle="projects.settings.fields.tasks.subtitle"
            article={{
              intlId: `projects.settings.fields.tasks.article`,
              link: retrieveDoc({ supportPage: `tasks`, language: user?.language.value }),
            }}
          />
        </Grid>
      </Grid>

      <GetDescriptionFields
        type="task"
        project={project}
        descriptionFields={descriptionFields}
        showCustomFields={true}
      />
    </div>
  );
};
